import { Control, Controller } from "react-hook-form";
import { useMemo } from "react";
import { ClientInfoForm } from "features/ClientInfo/ClientInfo";
import { useGetPriceList } from "shared-apis/api";
import { PriceListItem } from "types";

import { NamedSelect } from "components/NamedSelect/NamedSelect";
import { NamedInput } from "components/NamedInput/NamedInput";
import { VerticalSpace } from "components/VerticalSpace/VerticalSpace";

import styles from "../../styles.module.css";

type Props = {
  control: Control<ClientInfoForm>;
};

export function AdditionalInfo({ control }: Props) {
  const { data: priceList = [] } = useGetPriceList();

  const priceListOptions = useMemo(() => {
    return priceList.map((item: PriceListItem) => ({
      value: item.pricelistid,
      label: item.name,
    }));
  }, [priceList]);

  return (
    <div className={styles.container}>
      <Controller
        name="pricelistid"
        control={control}
        render={({ field }) => (
          <NamedSelect
            {...field}
            onChange={(e: any) => {
              field.onChange(e?.value);
            }}
            value={priceListOptions.find(
              (item: any) => Number(item.value) === Number(field.value)
            )}
            options={priceListOptions}
            name="Прайс лист"
            containerClassName={styles.select_container}
            nameClassName={styles.select_name}
            isClearable
          />
        )}
      />

      <div className="mt-5">
        <Controller
          name="comment"
          control={control}
          render={({ field }) => (
            <NamedInput
              {...field}
              label="Комментарий"
              style={{ width: "100%" }}
              isLabelRegular
            />
          )}
        />
      </div>

      <VerticalSpace size={40} />
    </div>
  );
}
